import { createRouter, createWebHistory } from "vue-router";
import type {
  RouteComponent,
  RouteRecordRaw,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded
} from "vue-router";
import { routerGuard } from "@/router/routerGuard";
import { AppPathConfig } from "@/helper/app_path_config";

export type RouteMeta = {
  myProperty?: string;
};

const isApplicationInHub = () => {
  return window?.location.pathname.includes(AppPathConfig.hubPathName);
};

const webHistoryURL = (isApplicationInHub() ? AppPathConfig.hubPathName : "") + AppPathConfig.appRouteBaseURL;

export type RouteRecordRawCustom = RouteRecordRaw & {
  meta?: RouteMeta;
};

const routes: RouteRecordRaw[] = [
  {
    path: "/search",
    name: "Search",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: true
  },
  {
    path: "/vessel-schedule",
    name: "VesselSchedule",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: { journey: "schedule" }
  },
  {
    path: "/import",
    name: "Import",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: { journey: "import" }
  },
  {
    path: "/export",
    name: "Export",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: { journey: "export" }
  },
  {
    path: "/history",
    name: "History",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: { journey: "history" }
  },
  {
    path: "/emptyContainers",
    name: "EmptyContainers",
    meta: {},
    component: (): Promise<RouteComponent> => import("@/views/HomeView.vue"),
    props: { journey: "emptyContainers" }
  },
  { path: "/:pathMatch(.*)*", redirect: "/import" }
];

export const scrollBehavior = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalizedLoaded,
  savedPosition: any | null
) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { left: 0, top: 0, behaviour: "smooth" };
  }
};

const getRouter = () => {
  const router = createRouter({
    history: createWebHistory(`${webHistoryURL}`),
    scrollBehavior,
    routes
  });
  router.beforeEach(routerGuard);
  return router;
};

export default getRouter;
